const DAY = 86400000;
const PRIORITY = ["review", "unknown", "nextAction", "unselected"];

function reasonFor(d, now) {
  if (d.reviewAt && new Date(d.reviewAt) - now <= 7 * DAY) return "review";
  if (d.items?.some((i) => i.epistemic === "UNKNOWN" && i.lifecycle !== "discarded")) return "unknown";
  if (d.nextAction) return "nextAction";
  if (["draft", "composing", "ready"].includes(d.status) && d.chooseBy && new Date(d.chooseBy).getTime() < now) return "unselected";
  return null;
}

export function pickAttention(list, now = Date.now()) {
  const pinned = list.filter((d) => d.attentionPinned).slice(0, 3);
  const rest = list.filter((d) => !d.attentionPinned && reasonFor(d, now))
    .sort((a, b) => PRIORITY.indexOf(reasonFor(a, now)) - PRIORITY.indexOf(reasonFor(b, now)));
  return [...pinned, ...rest].slice(0, 3).map((d) => ({ ...d, reason: reasonFor(d, now) }));
}
